import FtIcon from './FtIcon';

FtIcon.install = function(Vue) {
  Vue.component(FtIcon.name, FtIcon);
};

export default FtIcon;
